// src/utils.ts
export function generateRandomCode(): string {
    const digits = '0123456789';
    let code = '';
    for (let i = 0; i < 16; i++) {
      code += digits.charAt(Math.floor(Math.random() * digits.length));
    }
    return code;
  }
  